export default __webpack_public_path__ + "static/media/male_white.f94613c1.svg";